function formResize(size) {
  const popups = document.querySelectorAll(".ac-popup");
  popups.forEach((popup) => {
    if (size === "lg") {
      popup.classList.add("ac-popup--lg");
      popup.classList.remove("ac-popup--sm");
    } else if (size === "sm") {
      popup.classList.add("ac-popup--sm");
      popup.classList.remove("ac-popup--lg");
    } else {
      popup.classList.add("ac-popup--md");
      popup.classList.remove("ac-popup--lg");
      popup.classList.remove("ac-popup--sm");
    }
  });
}
function showSpinner() {
  const spinner = document.querySelector("[data-spinner-wrap]");
  if (spinner) {
    spinner.style.display = "block";
  }
}

function hideSpinner() {
  const spinner = document.querySelector("[data-spinner-wrap]");
  if (spinner) {
    spinner.style.display = "none";
  }
}

function toggleSpinner(show) {
  const spinner = document.querySelector("[data-spinner-wrap]");
  if (spinner) {
    spinner.style.display = show ? "block" : "none";
  }
}

function initializeDropdown(dropdownElement) {
  const dropdownToggleBtns = dropdownElement.querySelectorAll(
    "[data-dropdown-toggle]"
  );
  const dropdownMenu = dropdownElement.querySelector("[data-dropdown-menu]");
  dropdownToggleBtns.forEach((dropdownToggle) => {
    const dropdownMenu = document.querySelector(
      `[data-dropdown-menu="${dropdownToggle.dataset.dropdownToggle}"]`
    );
    const closeButton = dropdownMenu.querySelector("[data-dropdown-close]");

    dropdownToggle.addEventListener("click", () => {
      dropdownMenu.classList.toggle("active");
    });

    closeButton.addEventListener("click", () => {
      dropdownMenu.classList.remove("active");
    });
  });
}

  const closePopups = document.querySelectorAll('[data-close-popup-btn]');
  closePopups.forEach(element => {
    element.addEventListener("click", (event) => {
      event.preventDefault();
      closePopup();
    });
  });

  function closePopup() {
    const elementsToRemove = document.querySelectorAll('.tingle-modal.tingle-modal--visible');
    elementsToRemove.forEach(element => {
      element.classList.remove('tingle-modal--visible');
      // close popup fix start
      if (document.body.classList.contains('tingle-enabled')) {
            document.body.classList.remove('tingle-enabled');
      }
      if (document.documentElement.classList.contains('tingle-enabled')) {
          document.documentElement.classList.remove('tingle-enabled');
      }
      // close popup fix end
    })
  }

  function loadGoogleMapsAPI(callback) {
    if (typeof google === 'object' && typeof google.maps === 'object') {
      if (callback) callback();
      return;
    }
  
    window.googleMapsAPILoaded = function () {
      if (callback) callback();
    };
  
    // Create script element to load Google Maps API
    const script = document.createElement('script');
    script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyD3mdhgTpQYe9SFCwyZk2HPV3nySnLbIdo&libraries=places&callback=googleMapsAPILoaded';
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
  }
  
  function initAutocomplete() {
    loadGoogleMapsAPI(function () {
      initializeAutocompleteForForms();
    });
  }
  function movePacContainer(autocomplete, inputField) {
    return new Promise((resolve, reject) => {
      let attempts = 0;
      const maxAttempts = 20;
  
      const interval = setInterval(() => {
        const pacContainers = document.querySelectorAll('.pac-container');
        const pacContainer = pacContainers[pacContainers.length - 1];
  
        if (pacContainer && !pacContainer.getAttribute('data-autocomplete-id')) {
          // Associate the PAC container with the autocomplete instance
          pacContainer.setAttribute('data-autocomplete-id', autocomplete.uniqueId);
  
          // Move the PAC container next to the input field
          inputField.parentNode.appendChild(pacContainer);
  
          clearInterval(interval);
          resolve();
        } else {
          attempts++;
          if (attempts >= maxAttempts) {
            clearInterval(interval);
            reject('PAC container not found');
          }
        }
      }, 100);
    });
  }
  async function initializeAutocompleteForForms() {
    const forms = document.querySelectorAll('[data-account-block]');
    for (const form of forms) {
      const blockType = form.getAttribute('data-account-block');
      if (
        blockType === 'salon' ||
        blockType === 'shipping' ||
        blockType === 'registration'
      ) {
        const address1Field = form.querySelector('[data-address1-field]');
        const address2Field = form.querySelector('[data-address2-field]');
        const cityField = form.querySelector('[data-city-field]');
        const stateField = form.querySelector('[data-state-field]');
        const zipField = form.querySelector('[data-zip-field]');
        const countryField = form.querySelector('[data-country-field]');
        if (address1Field) {
          // Determine country restriction based on store region
          const storeId = window.proStoreId || 'US'; // Default to US if not set
          const countryRestriction = storeId === 'CA' ? 'CA' : 'US';

          const config = {
            address1Field,
            address2Field,
            cityField,
            stateField,
            zipField,
            countryField,
            countryRestriction: countryRestriction,
          };
          try {
            await setupAutocomplete(config);
          } catch (error) {
            console.error('Error initializing autocomplete:', error);
          }
        }
      }
    }
    console.log('All autocomplete instances initialized');
  }
  async function setupAutocomplete(config) {
    const {
      address1Field,
      address2Field,
      cityField,
      stateField,
      zipField,
      countryField,
      countryRestriction,
    } = config;
  
    const uniqueId = 'autocomplete-' + Math.random().toString(36).substr(2, 9);
    address1Field.setAttribute('data-autocomplete-id', uniqueId);
  
    const autocomplete = new google.maps.places.Autocomplete(address1Field, {
      componentRestrictions: { country: countryRestriction },
      fields: ['address_components', 'geometry'],
      types: ['address'],
    });
  
    autocomplete.uniqueId = uniqueId;
  
    // Wait for the .pac-container to be created and move it
    await movePacContainer(autocomplete, address1Field);
  
  autocomplete.addListener('place_changed', function () {
    fillInAddress(autocomplete, {
      address1Field,
      address2Field,
      cityField,
      stateField,
      zipField,
      countryField,
    });
  });

  // Restore PAC container visibility when user focuses on address1 field again
  address1Field.addEventListener('focus', function() {
    setTimeout(() => {
      const pacContainers = document.querySelectorAll('.pac-container');
      if (pacContainers.length > 0) {
        console.log('🔄 Restoring PAC container visibility');
        pacContainers.forEach(container => {
          container.style.display = '';
          container.style.visibility = '';
        });
      }
    }, 50);
  });
}

  function fillInAddress(autocomplete, fields) {
    const place = autocomplete.getPlace();
    let address1 = "";
    let postcode = "";
    // Iterate through the address components
    for (const component of place.address_components) {
      const componentType = component.types[0];
        
      switch (componentType) {
        case "street_number":
          address1 = `${component.long_name} ${address1}`;
          break;
        case "route":
          address1 += component.short_name;
          break;
        case "postal_code":
          postcode = `${component.long_name}${postcode}`;
          break;
        case "postal_code_suffix":
          postcode = `${postcode}-${component.long_name}`;
          break;
        case "locality":
          if (fields.cityField) {
            fields.cityField.value = component.long_name;
          }
          break;
        case "administrative_area_level_1":
          const stateCode = component.short_name;
          if (fields.stateField) {
            selectOptionInDropdown(fields.stateField, stateCode);
          }
          break;
      }
    }
    fields.address1Field.value = address1;
    fields.zipField.value = postcode;

    // Clear validation errors for filled fields
    const clearFieldError = (field) => {
      if (!field) return;
      field.classList.remove('invalid');
      const errorElement = field.nextElementSibling;
      if (errorElement && errorElement.classList.contains('ac-text--error')) {
        errorElement.textContent = '';
        errorElement.style.display = 'none';
      }
    };

    clearFieldError(fields.address1Field);
    clearFieldError(fields.cityField);
    clearFieldError(fields.stateField);
    clearFieldError(fields.zipField);

    // Trigger input AND change events for address1Field so trackFormChanges() detects it
    // and form validation runs to enable the Save button
    if (fields.address1Field) {
      fields.address1Field.dispatchEvent(new Event('input', { bubbles: true }));
      fields.address1Field.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (fields.address2Field) fields.address2Field.dispatchEvent(new Event('input'));
    if (fields.cityField) {
      fields.cityField.dispatchEvent(new Event('input'));
      fields.cityField.dispatchEvent(new Event('change'));
    }
    if (fields.stateField) fields.stateField.dispatchEvent(new Event('change'));
    if (fields.zipField) {
      fields.zipField.dispatchEvent(new Event('input'));
      fields.zipField.dispatchEvent(new Event('change'));
    }
    // Intentionally NOT dispatching an input event for countryField so it won't be updated
    // if (fields.countryField) fields.countryField.dispatchEvent(new Event('input'));
  
    // Move focus to the second address line immediately
    if (fields.address2Field) {
      fields.address2Field.focus();
    }

    // Force close the autocomplete dropdown after a short delay
    setTimeout(() => {
      const pacContainers = document.querySelectorAll('.pac-container');
      if (pacContainers.length > 0) {
        console.log('✅ Closing PAC container after address selection');
        pacContainers.forEach(container => {
          container.style.display = 'none';
          container.style.visibility = 'hidden';
        });
      }
    }, 50);
  }
  
  function selectOptionInDropdown(selectElement, value) {
    console.log('select option in dropdown');
    console.log('selected value', value)
    for (let i = 0; i < selectElement.options.length; i++) {
      if (selectElement.options[i].value.toUpperCase() === value.toUpperCase()) {
        selectElement.selectedIndex = i;
        break;
      }
    }
  }
  function isRegistrationPage() {
    // Check if the URL hash is '#register' or the pathname includes '/register'
    return window.location.hash === '#register' || window.location.pathname.includes('/register');
  }
  function attachPasswordHider(){
    document.addEventListener('click', function(e) {
      if(e.target.classList.contains('toggle-password-icon')){
        let passwordInput = e.target.parentNode.querySelector(".toggle-password-visibility");
        let togglePassword = e.target;
        let closedEyeSrc = togglePassword.getAttribute('data-closed-eye');
        let openedEyeSrc = togglePassword.getAttribute('data-opened-eye');
        let isPasswordVisible = passwordInput.getAttribute('type') === 'text';
        passwordInput.setAttribute('type', isPasswordVisible ? 'password' : 'text');
        e.target.src = isPasswordVisible ?  closedEyeSrc : openedEyeSrc;
      }
    });
  }

  function showToast(title, message, duration, className = '') {
    // Create toast element
    const toast = document.createElement('div');
    toast.classList.add('toast');

      if (className) {
          toast.classList.add(className);
      }

    // Add content
    toast.innerHTML = `
      <div>
        <strong>${title}</strong>
        <div>${message}</div>
      </div>
      <button class="close-btn">&times;</button>
    `;

    // Append to the container
    let container = document.querySelector('.toast-container');
    if (!container) {
      container = document.createElement('div');
      container.classList.add('toast-container');
      document.body.appendChild(container);
    }
    container.appendChild(toast);
    if(!!duration){
      setTimeout(() => {
        toast.style.animation = 'fadeOut 0.5s forwards';
        toast.addEventListener('animationend', () => toast.remove());
      }, duration);
    }
    // Remove toast after specified duration

    // Add close button functionality
    toast.querySelector('.close-btn').addEventListener('click', () => {
      toast.style.animation = 'fadeOut 0.5s forwards';
      toast.addEventListener('animationend', () => toast.remove());
    });
  }


  // Initialize Autocomplete on DOMContentLoaded
  document.addEventListener('DOMContentLoaded', function () {
    if (!isRegistrationPage()) {
      initAutocomplete();
    }
    attachPasswordHider();
  });

window.translations = window.translations || {
    iwish: {
      en: {
        addFavorite: "added to wishlist",
        removeFavorite: "removed from wishlist",
      },
      fr: {
        addFavorite: "ajouté à la liste de souhaits",
        removeFavorite: "retiré de la liste de souhaits",
      },
    },
    common: {
      en: {
        save: "Save",
        cancel: "Cancel",
      },
      fr: {
        save: "Enregistrer",
        cancel: "Annuler",
      },
    },
    fogotPassword: {
        en: {
            emptyField: "please enter a valid email address",
        },
        fr: {
          emptyField: "veuillez entrer une adresse e-mail valide",
        },
    },
    sideCart: {
      en: {
        title: "your rewards order",
        emptyCart: "your cart is empty",
        browseProduct: "browse products",
        freeshipWaySub: "you're",
        freeshipWay: "away from qualifying for free shipping",
        freeText: "you've earned free shipping",
        freeShipping: "salon merch items do not qualify for free shipping",
        finalSale: "**final sale**",
        notQualified: "does not qualify for free shipping",
        free: "free",
        maxError: "you can add only",
        maxErrorSup: "sample",
        orderTotal: "order total",
        submitOrder: "SUBMIT ORDER",
        rewardsOrder: "rewards orders are limited to one per month"
      },
      fr: {
        title: "votre commande de récompenses",
        emptyCart: "votre panier est vide",
        browseProduct: "parcourir les produits",
        freeshipWaySub: "vous êtes",
        freeshipWay: "à quelques pas de la qualification pour la livraison gratuite",
        freeText: "vous avez gagné la livraison gratuite",
        freeShipping: "les articles de merchandising de salon ne sont pas éligibles à la livraison gratuite",
        finalSale: "**solde final**",
        notQualified: "n’est pas éligible à la livraison gratuite",
        free: "gratuit",
        maxError: "vous pouvez ajouter seulement",
        maxErrorSup: "échantillon",
        orderTotal: "total de la commande",
        submitOrder: "SOUMETTRE LA COMMANDE",
        rewardsOrder: "les commandes de récompenses sont limitées à une par mois"
      }
    },
  };

function getErrorMessage(key) {
  const selectedLanguage = localStorage.getItem('selectedLanguage') || 'en';
  const errorMessage = errorMessages.errors[selectedLanguage][key];
  console.log({selectedLanguage}, {errorMessage});
  return errorMessage || key;
}

// Get hubspot infor from cache

function getPointsCache(customerId) {
  const cacheKey = `customerHubspotProfile_${customerId}`;
  const cachedData = JSON.parse(localStorage.getItem(cacheKey) || '{}');
  const properties = cachedData?.response?.properties;
      if (properties) {
          // Return only the main points value (do not include preselected_reward_points)
          return Number(properties.points || 0);
      }

  return null;
}

function waitForPoints(customerId, timeout = 2000, interval = 100) {
  return new Promise((resolve) => {
    const startTime = Date.now();
    const check = () => {
      const totalPoints = getPointsCache(customerId);
      if (typeof totalPoints === 'number' && !isNaN(totalPoints)) {
        resolve(totalPoints);
      } else if (Date.now() - startTime >= timeout) {
        resolve(0); // fallback
      } else {
        setTimeout(check, interval);
      }
    };
    check();
  });
}

// ============================================
// NORMALIZATION HELPERS (FIELD_NORMALIZATION_QA)
// ============================================

// Basic normalization: lowercase (for emails)
function normalizeToLowerCase(value) {
    return value ? value.trim().toLowerCase() : '';
}

// Basic normalization: Capitalize Each Word (for names, addresses, cities)
function normalizeToCapitalize(value) {
    if (!value) return '';
    return value
        .trim()
        .split(/\s+/)
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
}

// Basic normalization: UPPERCASE (for postal codes, short province codes)
function normalizeToUpperCase(value) {
    return value ? value.trim().toUpperCase() : '';
}

// Specialized: format Canadian postal code to 'K1A 0B1' format
function formatCanadianZipCode(zip) {
    if (!zip) return '';
    const s = String(zip).toUpperCase().replace(/\s+/g, '');
    const noSpacePattern = /^[A-Z]\d[A-Z]\d[A-Z]\d$/;
    if (noSpacePattern.test(s)) {
        return s.slice(0, 3) + ' ' + s.slice(3);
    }
    return String(zip).toUpperCase();
}

// Specialized: validate postal/zip code for US and Canada
function validateZipCode(postalCode, country) {
    if (!postalCode) return false;
    const s = String(postalCode).trim();
    const countryNorm = (country || '').toString().trim().toLowerCase();
    const postalPatternUSA = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
    const postalPatternCanada = /^[A-Za-z]\d[A-Za-z]\s?\d[A-Za-z]\d$/;

    if (countryNorm === 'canada' || countryNorm === 'ca') {
        return postalPatternCanada.test(s.toUpperCase());
    }
    return postalPatternUSA.test(s);
}

// Specialized: normalize province/state (UPPERCASE for 2-char codes, Capitalize for full names)
function normalizeProvinceState(value) {
    if (!value) return '';
    const trimmed = String(value).trim();
    if (trimmed.length === 2) return normalizeToUpperCase(trimmed);
    return normalizeToCapitalize(trimmed);
}

// Specialized: normalize country for account forms (returns code: US/CA)
function normalizeCountryForAccount(value) {
    if (!value) return '';
    const trimmed = String(value).trim();
    const lc = trimmed.toLowerCase();
    if (trimmed.length === 2) return normalizeToUpperCase(trimmed);
    if (lc === 'united states' || lc === 'usa') return 'US';
    if (lc === 'canada') return 'CA';
    return trimmed;
}

// ============================================
// END NORMALIZATION HELPERS
// ============================================